import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CssBaseline from '@material-ui/core/CssBaseline'
import LockPersonRoundedIcon from '@mui/icons-material/LockOpenRounded'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import { makeStyles } from '@material-ui/core/styles'
import { Link, useNavigate } from 'react-router-dom'
import MuiPhoneNumber from 'material-ui-phone-number'
import axios from 'axios'
import { Apis } from '../../Apis/Apis'
import { AuthToken } from 'app/auth/AuthToken'
import validator from 'validator'
import Alert from '@mui/material/Alert'
const drawerWidth = 240

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}))

function Profile(props) {
    const classes = useStyles()
    const [message, setMessage] = useState()
    const [phoneNum, setPhoneNum] = useState()
    const [emailErr, setEmailErr] = useState()
    const [userData, setUserData] = useState()
    const [imgdata, setImgdata] = useState()
    const navigate = useNavigate()
    const imageUrl = imgdata?.name ? URL.createObjectURL(imgdata) : imgdata

    const imgHandleChange = (e) => {
        setImgdata(e.target.files[0])
    }

    const [alldata, setAllData] = useState({
        name: '',
        username: '',
        email: '',
        qualification: '',
        address: '',
    })

    const handleChange = (e) => {
        setAllData({
            ...alldata,
            [e.target.name]: e.target.value,
        })
    }

    let config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
    }
    const currentUser = async () => {
        await axios
            .get(`${Apis.getLoginUserData}`, config)
            .then((res) => {
                setUserData(res?.data?.data)
            })
            .catch((err) => {
                console.log('error in currentUser apis', err)
            })
    }
    useEffect(() => {
        currentUser()
    }, [])

    const setState = () => {
        console.log(userData)
        setAllData({
            name: userData?.name,
            username: userData?.username,
            email: userData?.email,
            address: userData?.address,
        })
        setImgdata(userData?.image)
        setPhoneNum(userData?.mobilenumber)
    }

    useEffect(() => {
        setState()
    }, [userData])

    const validateEmail = (value) => {
        if (validator.isEmail(value)) {
            setEmailErr(true)
        } else {
            setEmailErr('Contains invalid characters!')
        }
    }
    useEffect(() => {
        validateEmail(alldata.email || '')
    })

    const handleSubmit = () => {
        var formdata = new FormData()
        formdata.append('name', alldata.name)
        formdata.append('username', alldata.username)
        formdata.append('email', alldata.email)
        formdata.append('address', alldata.address)
        formdata.append('mobilenumber', phoneNum)
        formdata.append('image', imgdata)

        if (
            !alldata.name ||
            !alldata.username ||
            !alldata.role ||
            !alldata.email ||
            !alldata.address ||
            !phoneNum
        ) {
            if (!alldata.name) {
                setMessage('Name is required !')
            } else {
                if (!alldata.username) {
                    setMessage('Username is required !')
                } else {
                    if (!alldata.email || emailErr != true) {
                        !alldata.email
                            ? setMessage('Email is required !')
                            : setMessage('Add valid email!')
                    } else {
                        if (!phoneNum) {
                            setMessage('Phone number is required !')
                        } else {
                            if (!alldata.address) {
                                setMessage('Address is required !')
                            } else {
                                axios
                                    .put(
                                        `${Apis.editLoginUserDetails}`,

                                        formdata,
                                        {
                                            headers: {
                                                Authorization: `Bearer ${localStorage.getItem(
                                                    'accessToken'
                                                )}`,
                                            },
                                        }
                                    )
                                    .then((res) => {
                                        localStorage.setItem(
                                            'UserInfo',
                                            JSON.stringify([
                                                alldata?.name,
                                                imageUrl,
                                            ])
                                        )
                                        setMessage([
                                            res?.data?.message ||
                                                'Profile updated successfully',
                                            res?.data?.code,
                                        ])

                                        setTimeout(() => {
                                            navigate(
                                                '/dashboard/approvedAppointments'
                                            )
                                        }, 2000)
                                    })
                                    .catch((err) => {
                                        console.log('Error in form data', err)
                                    })
                            }
                        }
                    }
                }
            }
        }
    }

    return (
        <Box>
            {message ? (
                <Alert
                    severity={message[1] === 200 ? 'success' : 'error'}
                    sx={{ position: 'fixed', width: '80%' }}
                >
                    {message.length === 2 ? message[0] : message}
                </Alert>
            ) : (
                ''
            )}
            <div className={classes.root}>
                <CssBaseline />

                <div>
                    <div className={classes.toolbar} />
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            p: 3,
                            width: { sm: `calc(100%   )` },
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={2} md={2}>
                                <Box sx={{ paddingBottom: 3 }}>
                                    <Link
                                        to={'/dashboard/user-profile'}
                                        style={{
                                            textDecoration: 'none',
                                            color: 'black',
                                        }}
                                    >
                                        <PersonOutlineIcon />
                                        Basic Information
                                    </Link>
                                </Box>
                                <Box sx={{ paddingBottom: 3 }}>
                                    <Link
                                        to={'/dashboard/user-password'}
                                        style={{
                                            textDecoration: 'none',
                                            color: 'black',
                                        }}
                                    >
                                        <LockPersonRoundedIcon />
                                        Password
                                    </Link>
                                </Box>
                            </Grid>
                            <Box
                                xs={1}
                                md={1}
                                sx={{
                                    border: 'solid',
                                    borderColor: 'gray',
                                    borderWidth: 'thin',
                                }}
                            ></Box>

                            <Grid item xs={9} md={9}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        width: '50%',
                                    }}
                                >
                                    <img
                                        src={imageUrl || imgdata}
                                        alt=""
                                        style={{
                                            width: '75px',
                                            height: '75px',
                                            position: 'relative',
                                            borderRadius: '50px',
                                            left: '2%',
                                        }}
                                    />
                                    <input
                                        type="file"
                                        id="avatarUpload"
                                        style={{ display: 'none' }}
                                        onChange={imgHandleChange}
                                    />
                                    <Button
                                        variant="contained"
                                        sx={{
                                            marginLeft: 1,
                                            minWidth: 'fit-content',
                                        }}
                                    >
                                        {' '}
                                        <label htmlFor="avatarUpload">
                                            Change Avatar
                                        </label>
                                    </Button>

                                    <Button
                                        variant="outline"
                                        size="small"
                                        onClick={() => {
                                            setImgdata('')
                                        }}
                                    >
                                        Remove
                                    </Button>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                        <Box
                                            component="form"
                                            sx={{
                                                '& > :not(style)': {
                                                    m: 1,
                                                    width: '80%',
                                                },
                                            }}
                                            noValidate
                                            autoComplete="off"
                                        >
                                            <TextField
                                                id="outlined-basic"
                                                label="Name"
                                                variant="outlined"
                                                name="name"
                                                onChange={handleChange}
                                                value={alldata.name}
                                            />
                                            <TextField
                                                id="outlined-basic"
                                                label="Username"
                                                variant="outlined"
                                                name="username"
                                                onChange={handleChange}
                                                value={alldata.username}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={5} md={5}>
                                        <Box
                                            component="form"
                                            sx={{
                                                '& > :not(style)': {
                                                    m: 1,
                                                    width: '80%',
                                                },
                                            }}
                                            noValidate
                                            autoComplete="off"
                                        >
                                            <MuiPhoneNumber
                                                label="Phone Number"
                                                defaultCountry={'us'}
                                                variant="outlined"
                                                name="phone"
                                                value={phoneNum}
                                                sx={{
                                                    paddingBottom: 1,
                                                    width: '30vh',
                                                }}
                                                onChange={(e) => {
                                                    setPhoneNum(e)
                                                }}
                                            />

                                            <TextField
                                                id="outlined-basic"
                                                label="Email"
                                                variant="outlined"
                                                name="email"
                                                value={alldata.email}
                                                onChange={handleChange}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Box
                                        component="form"
                                        sx={{
                                            '& > :not(style)': {
                                                m: 1,
                                                width: '40vw',
                                            },
                                        }}
                                        noValidate
                                        autoComplete="off"
                                    >
                                        <TextField
                                            id="outlined-basic"
                                            label="Address"
                                            name="address"
                                            value={alldata.address}
                                            onChange={handleChange}
                                            multiline
                                            variant="outlined"
                                        />
                                    </Box>
                                </Grid>
                                <Button
                                    variant="contained"
                                    className="m-2"
                                    onClick={handleSubmit}
                                >
                                    {' '}
                                    Save Changes
                                </Button>

                                <Button
                                    onClick={() => {
                                        navigate(
                                            '/dashboard/approvedAppointments'
                                        )
                                    }}
                                    variant="contained"
                                    className="m-2"
                                >
                                    {' '}
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </div>
            </div>
        </Box>
    )
}

Profile.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
}

export default Profile
